import React from 'react';
import { PXTextModalWrapper } from 'Views/Page/Content/Modal/Layouts/PXTextModalWrapper';
import MetaLayoutRemainingFields from 'Components/UI/Meta/MetaForm/Components/MetaLayout/MetaLayoutRemainingFields';

export const Layout = () => {
  return (
    <PXTextModalWrapper>
      <MetaLayoutRemainingFields noAccordion />
    </PXTextModalWrapper>
  );
};
